/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Represents an asset (image, file, etc.)
 * @export
 * @interface Asset
 */
export interface Asset {
    /**
     *
     * @type {string}
     * @memberof Asset
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof Asset
     */
    url?: string | null;
    /**
     *
     * @type {string}
     * @memberof Asset
     */
    fileName?: string | null;
    /**
     *
     * @type {string}
     * @memberof Asset
     */
    contentType?: string | null;
    /**
     *
     * @type {number}
     * @memberof Asset
     */
    width?: number | null;
    /**
     *
     * @type {number}
     * @memberof Asset
     */
    height?: number | null;
    /**
     *
     * @type {number}
     * @memberof Asset
     */
    size?: number | null;
    /**
     *
     * @type {string}
     * @memberof Asset
     */
    description?: string | null;
}

/**
 * Check if a given object implements the Asset interface.
 */
export function instanceOfAsset(value: object): value is Asset {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function AssetFromJSON(json: any): Asset {
    return AssetFromJSONTyped(json, false);
}

export function AssetFromJSONTyped(json: any, _: boolean): Asset {
    if (json == null) {
        return json;
    }
    return {

        'title': json['title'],
        'url': json['url'] ?? undefined,
        'fileName': json['file_name'] ?? undefined,
        'contentType': json['content_type'] ?? undefined,
        'width': json['width'] ?? undefined,
        'height': json['height'] ?? undefined,
        'size': json['size'] ?? undefined,
        'description': json['description'] ?? undefined,
    };
}

export function AssetToJSON(json: any): Asset {
    return AssetToJSONTyped(json, false);
}

export function AssetToJSONTyped(value?: Asset | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'title': value['title'],
        'url': value['url'],
        'file_name': value['fileName'],
        'content_type': value['contentType'],
        'width': value['width'],
        'height': value['height'],
        'size': value['size'],
        'description': value['description'],
    };
}
